import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const weekPlanHeaderHeight = '217px';

export const WeekPlanHeaderContainer = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  ${({ theme }) => css`
    border-top-right-radius: ${theme.radii[200]};
    border-top-left-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
    min-height: ${weekPlanHeaderHeight};
    & > * {
      &:last-child > :first-child {
        padding-bottom: ${theme.spacings[500]};
      }
    }
  `}
`;

export const WeekPlanStyled = styled(Box)`
  height: 100%;
  ${({ theme }) => css`
    & > * {
      &:not(:last-child) {
        border-right: solid 1px ${theme.colors.grey[400]};
      }
    }
  `};
`;
